<template>
  <v-menu>
    <template #activator="{ props: propsActivator }">
      <v-btn icon flat variant="plain" v-bind="propsActivator">
        <v-icon>mdi-sort-variant</v-icon>
        <v-tooltip activator="parent" location="start">{{ t('common.actions.sort') }}</v-tooltip>
      </v-btn>
    </template>
    <v-card tile>
      <v-toolbar class="theme_surface_light_background">
        <v-toolbar-title class="body-1">
          {{ t('views.sort.title') }}
        </v-toolbar-title>
        <v-btn icon small>
          <v-icon>mdi-close</v-icon>
          <v-tooltip activator="parent" location="end">{{ t('common.actions.close') }}</v-tooltip>
        </v-btn>
      </v-toolbar>
      <v-container class="theme_background theme_lighten">
        <v-row>
          <v-col>
            <v-radio-group v-model="selectedItem" hide-details>
              <v-radio v-for="item of SortOptions" :key="item.name" :label="t(item.label)" :value="item" />
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script lang="ts" setup>
// Framework import
import type { PropType } from 'vue'

import { useVModel } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

import type { SortOptionType } from '@/constants/SortOptions'
import SortOptions from '@/constants/SortOptions'

const props = defineProps({
  modelValue: {
    type: Object as PropType<SortOptionType>,
    required: true
  }
})

const emits = defineEmits<{
  (event: 'update:modelValue', item: number): void
}>()

const selectedItem = useVModel(props, 'modelValue', emits)

const { t } = useI18n()
</script>

<style scoped></style>
